import { z } from 'zod';

const SCHEMA = z.object({
  initialValue: z.coerce.number(),
  currency: z.string().default('USD'),
  locale: z.string().default('en-US'),
});

export default function currency(initialValue: unknown, currency?: unknown, locale?: unknown) {
  const res = SCHEMA.safeParse({
    initialValue,
    currency,
    locale,
  });

  if (res.error) {
    return '';
  }

  const v = res.data;
  return (
    new Intl.NumberFormat(v.locale, { style: 'currency', currency: v.currency })
      .format(v.initialValue)
      // We replace whitespace characters with empty spaces because the node
      // implementation has special characters instead of spaces
      .replace(/\s/g, ' ')
  );
}
